/* tslint:disable */
/* eslint-disable */
/**
 * Adyen Card Enrollment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateActionResultResponseData,
    CreateActionResultResponseDataFromJSON,
    CreateActionResultResponseDataToJSON,
    CreatePaymentResponseData,
    CreatePaymentResponseDataFromJSON,
    CreatePaymentResponseDataToJSON,
    Payment,
    PaymentFromJSON,
    PaymentToJSON,
} from '../models';

export interface CreateActionResultRequest {
    ocpApimSubscriptionKey: string;
    authorization: string;
    adyenSDKVersion: string;
    actionResult?: object;
}

export interface CreatePaymentRequest {
    ocpApimSubscriptionKey: string;
    authorization: string;
    adyenSDKVersion: string;
    paymentData?: Payment;
}

/**
 * 
 */
export class CardEnrollmentApi extends runtime.BaseAPI {

    /**
     */
    async createActionResultRaw(requestParameters: CreateActionResultRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<CreateActionResultResponseData>> {
        if (requestParameters.ocpApimSubscriptionKey === null || requestParameters.ocpApimSubscriptionKey === undefined) {
            throw new runtime.RequiredError('ocpApimSubscriptionKey','Required parameter requestParameters.ocpApimSubscriptionKey was null or undefined when calling createActionResult.');
        }

        if (requestParameters.authorization === null || requestParameters.authorization === undefined) {
            throw new runtime.RequiredError('authorization','Required parameter requestParameters.authorization was null or undefined when calling createActionResult.');
        }

        if (requestParameters.adyenSDKVersion === null || requestParameters.adyenSDKVersion === undefined) {
            throw new runtime.RequiredError('adyenSDKVersion','Required parameter requestParameters.adyenSDKVersion was null or undefined when calling createActionResult.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.ocpApimSubscriptionKey !== undefined && requestParameters.ocpApimSubscriptionKey !== null) {
            headerParameters['Ocp-Apim-Subscription-Key'] = String(requestParameters.ocpApimSubscriptionKey);
        }

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        if (requestParameters.adyenSDKVersion !== undefined && requestParameters.adyenSDKVersion !== null) {
            headerParameters['Adyen-SDK-Version'] = String(requestParameters.adyenSDKVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/action-result`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.actionResult as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateActionResultResponseDataFromJSON(jsonValue));
    }

    /**
     */
    async createActionResult(requestParameters: CreateActionResultRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<CreateActionResultResponseData> {
        const response = await this.createActionResultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createPaymentRaw(requestParameters: CreatePaymentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<CreatePaymentResponseData>> {
        if (requestParameters.ocpApimSubscriptionKey === null || requestParameters.ocpApimSubscriptionKey === undefined) {
            throw new runtime.RequiredError('ocpApimSubscriptionKey','Required parameter requestParameters.ocpApimSubscriptionKey was null or undefined when calling createPayment.');
        }

        if (requestParameters.authorization === null || requestParameters.authorization === undefined) {
            throw new runtime.RequiredError('authorization','Required parameter requestParameters.authorization was null or undefined when calling createPayment.');
        }

        if (requestParameters.adyenSDKVersion === null || requestParameters.adyenSDKVersion === undefined) {
            throw new runtime.RequiredError('adyenSDKVersion','Required parameter requestParameters.adyenSDKVersion was null or undefined when calling createPayment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.ocpApimSubscriptionKey !== undefined && requestParameters.ocpApimSubscriptionKey !== null) {
            headerParameters['Ocp-Apim-Subscription-Key'] = String(requestParameters.ocpApimSubscriptionKey);
        }

        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }

        if (requestParameters.adyenSDKVersion !== undefined && requestParameters.adyenSDKVersion !== null) {
            headerParameters['Adyen-SDK-Version'] = String(requestParameters.adyenSDKVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/payment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PaymentToJSON(requestParameters.paymentData),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePaymentResponseDataFromJSON(jsonValue));
    }

    /**
     */
    async createPayment(requestParameters: CreatePaymentRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<CreatePaymentResponseData> {
        const response = await this.createPaymentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
